import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static values = { isScopedByLocalities: Boolean }

  onSearchTriggered(searchEvent) {
    const newSearchParams = searchEvent.detail.paramsObj

    if (this.scopedByLocalities) this.includeSelectedLocalitiesInAutocompleteRequest(newSearchParams)
  }

  includeSelectedLocalitiesInAutocompleteRequest(newSearchParams) {
    const { locations } = newSearchParams

    this.autocompleter.mergeQueryStringParams({ locations: locations || [] })
  }

  get scopedByLocalities() {
    return this.isScopedByLocalitiesValue
  }

  get autocompleter() {
    return this.element['collection-select']
  }
}
